import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    fontFamily: 'Poppins, sans-serif',
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '11px',
    width: '100%',
  },
  headerContainer: {
    position: 'absolute',
    left: '5%',
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: {
    color: '#666C6F',
    fontSize: '13px',
    fontWeight: 600,
  },
  legendContainer: {
    width: '150px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    fontSize: '13px',
    fontWeight: 600,
  },
  femaleText: {
    background: '#FF3301',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textTransform: 'capitalize',
  },
  maleText: {
    marginLeft: '24px',
    background: '#2F6BF4',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textTransform: 'capitalize',
  },
});
